// extracted by mini-css-extract-plugin
export default {"pageContent":"MonComptePage_pageContent__PnCjs","section":"MonComptePage_section__e1HSF","content":"MonComptePage_content__ES5zc"};